import { NgModule } from '@angular/core';
import { PaginationComponent } from './pagination.component';
import { CommonModule } from '@angular/common';
import { FormBehaviorModule } from '@circe/form-behavior';
import { IconsModule } from '@circe/icons';

@NgModule({
  exports: [PaginationComponent],
  declarations: [PaginationComponent],
  imports: [
    CommonModule,
    FormBehaviorModule,
    IconsModule
  ]
})
export class PaginationModule {}
